import { BaseError } from '@kiplin/web-common/error';

export class MissingAppMountError extends BaseError {
  constructor() {
    super('a4b08f2b-9318-4f2a-9d10-9a8d2f2c3e67', 'Unable to find #app mount element');
  }
}

export class MissingAppPropError extends BaseError {
  constructor(propName: string) {
    super('9dcaf4af-7427-4d17-8fd5-f3b80cc96c19', `Missing required app prop "${propName}" on #app dataset.`);
  }
}
